// Suppress ResizeObserver loop limit exceeded error
const suppressResizeObserverError = () => {
  const originalError = window.console.error;
  window.console.error = (...args: any[]) => {
    if (args[0]?.includes?.('ResizeObserver loop completed with undelivered notifications')) {
      return;
    }
    originalError.apply(window.console, args);
  };
};

export default suppressResizeObserverError; 